import { mapState } from 'vuex';

import { getStarsHTML, decode } from 'utils/general';
import productBundle from 'mixins/product-bundle';

/**
 * Product How To Use component
 */
export default {
  components: {
    'vue-image': () => import('../vue-image/vue-image.vue'),
    'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
  },
  props: ['productJson', 'reviewsCount', 'reviewsAverage'],
  mixins: [productBundle],
  computed: {
    ...mapState('global'),
    stars() {
      if (!this.reviewsAverage) return '';
      return getStarsHTML(this.reviewsAverage);
    },
    totalReviews() {
      if (!this.reviewsCount) return '';
      return `(${this.reviewsCount})`;
    },
    productObject() {
      return JSON.parse(decode(this.productJson))
    },
  },
  async mounted() {
    if(this.productObject){
      if (this.productObject.bundled_products.length) {
        this.isBundle = true;
        await this.fetchBundleProductsByHandles(
          this.productObject.bundled_products,
        );
      }
    }
  }
};
